// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2WBO6","icon":"SortAdornment_icon__3U0tK","up":"SortAdornment_up__2-ugy","down":"SortAdornment_down__3u6kD","active":"SortAdornment_active__1JsWd"};